import React from 'react'
import Colors from '../assets/Colors';
import Fonts from '../assets/Fonts';
import classes from './RoomBox.module.css'

function RoomBox({ item, i, onClick, selectedroom }) {
    return (
        <div
            className={[classes.chatDiv].join(" ")}
            style={{
                backgroundColor:
                    selectedroom?.id === item.id &&
                    Colors.mainShadeOfSolitude,
            }}
            onClick={() => {
                onClick(item);
            }}
        >
            <div
                className={[classes.aCenter].join(" ")}
            >
                <div>
                    <img
                        src={item.img}
                        className={[classes.chatimg].join(" ")}
                    />
                </div>
                <div className={[classes.userChat].join(" ")}>
                    <p
                        style={{
                            ...Fonts.b3,
                            color: Colors.neutralShadesOfNero,
                        }}
                    >
                        {item.name}
                    </p>
                    <p
                        className={[
                            classes.mb4,
                            classes.userRoomMessage,
                        ].join(" ")}
                        style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                        }}
                    >
                        {item.lastMessage.message}
                    </p>
                    <p
                        style={{
                            ...Fonts.b2,
                            color: Colors.neutralShadesOfDimGray,
                            lineHeight: '20px',
                        }}
                    >
                        {item.event.status}
                    </p>
                </div>
            </div>
            <div>
                <p
                    style={{
                        ...Fonts.b2,
                        color: Colors.neutralShadesOfDimGray,
                        lineHeight: '20px',
                    }}
                    className={[classes.chatDivTime].join(" ")}
                >
                    {item.lastMessage.time}
                </p>
                {item.lastMessage.isSeen && (
                    <div
                        style={{ backgroundColor: Colors.mainShadeOfRed }}
                        className={[classes.seen].join(" ")}
                    />
                )}
            </div>
        </div>

    )
}

export default RoomBox